import React from "react";
import { Paths } from "./../constants/UrlConstants";
import { getPhone, getOpeningHours } from "../helpers/ContentStateHelper";

export default {
  Heading: <h2>My renewal</h2>,
  RenewalDate: "Renewal date",
  RenewalPremium: "Renewal premium",
  RenewalFrequency: "Annually",
  PleaseNoteDescription: (
    <p>
      <strong>Please note:</strong> Your subscription includes Insurance Premium
      Tax at the current rate set by the government.
    </p>
  ),
  DocumentsHeading: "My renewal documents",
  DocumentsDescription: (
    <p>
      These documents provide information about your membership including full
      details of what you are covered for, what isn't covered and how to make a
      claim. Please enable pop-ups when viewing them on tablets and phones.
    </p>
  ),
  ContactUsDescription: {
    Format2: props => (
      <React.Fragment>
        <p>
          If you're happy with everything, there’s no need to contact us - we'll
          renew your membership automatically. However, if you'd like to change
          anything about your membership, please call us on the number below and
          we'll be happy to help.
        </p>
        <p>
          <strong>{getPhone(props)}</strong>
        </p>
        <p>{getOpeningHours(props)}</p>
      </React.Fragment>
    ),
    HOL: props => (
      <React.Fragment>
        <p>
          If you're happy with everything, there’s no need to contact us - we'll
          renew your membership automatically. However, if you'd like to change
          anything about your membership, please call us on the number below and
          we'll be happy to help.
        </p>
        <p>
          <strong>0800 587 0956</strong>
        </p>
        <p>Monday to Friday – 8am to 6pm</p>
      </React.Fragment>
    ),
    Any: props => (
      <React.Fragment>
        <p>
          If you're happy with everything, there’s no need to contact us - we'll
          renew your membership automatically. However, if you'd like to change
          anything about your membership, please call us on the number below and
          we'll be happy to help.
        </p>
        <p>
          <strong>0800 587 0954</strong>
        </p>
        <p>Monday to Friday 8am to 6pm</p>
      </React.Fragment>
    )
  },
  DependantRenewalMembershipStatementMessage: {
    Format2:
      "Due to medical confidentiality we are only allowed to provide the renewal membership certificate to the lead member.",
    Any:
      "Due to medical confidentiality we are only allowed to provide the renewal membership guide to the lead member."
  },
  RenewalMembershipStatementMissing: {
    Any: (
      <p>
        Sorry, we're unable to display your renewal membership guide at the
        moment. Please try again later. If you continue to experience problems,
        please call us.
      </p>
    ),
    Format2: (
      <p>
        Sorry, we're unable to display your renewal membership certificate at
        the moment. Please try again later. If you continue to experience
        problems, please call us.
      </p>
    )
  },
  HowMuchCoverLastYearHeading: "How much this cover would have cost last year",
  HowMuchCoverLastYearDescription: (props, params) => (
    <React.Fragment>
      <p>
        Last year the cover you have now would have cost{" "}
        {params.LastYearTotalAnnualPremium} a year.
      </p>
    </React.Fragment>
  ),
  ShopAroundContentForFormat2MigrationDiscount: (
    <React.Fragment>
      <p>
        As you either made a change to your cover or enjoyed a special offer
        this amount may be different to the amount shown on your documents last
        year.
      </p>
      <p>
        Please check to make sure your cover is still appropriate for your
        needs.
      </p>
      <p>
        You have been with us for a number of years. You may be able to get the
        insurance cover you want at a better price if you shop around. We also
        have a range of other options which you may wish to consider.
      </p>
      <p>
        Not all insurance providers offer the same features and benefits and you
        may not be able to get the same cover with another insurer for medical
        conditions that you have now or have had in the past, including any
        previously paid for by us.
      </p>
    </React.Fragment>
  ),

  ShopAroundContentForFormat2Migration: (
    <React.Fragment>
      <p>
        Please check to make sure your cover is still appropriate for your
        needs.
      </p>
      <p>
        You have been with us for a number of years. You may be able to get the
        insurance cover you want at a better price if you shop around. We also
        have a range of other options which you may wish to consider.
      </p>
      <p>
        Not all insurance providers offer the same features and benefits and you
        may not be able to get the same cover with another insurer for medical
        conditions that you have now or have had in the past, including any
        previously paid for by us.
      </p>
    </React.Fragment>
  ),

  ShopAroundContentForFourthRenewalFCADiscount: (
    <React.Fragment>
      <p>
        As you either made a change to your cover or enjoyed a special offer
        this amount may be different to the amount shown on your documents last
        year.
      </p>
      <p>
        Please check to make sure your cover is still appropriate for your
        needs.
      </p>
      <p>
        You have been with us for a number of years. You may be able to get the
        insurance cover you want at a better price if you shop around. We also
        have a range of other options which you may wish to consider.
      </p>
      <p>
        Not all insurance providers offer the same features and benefits and you
        may not be able to get the same cover with another insurer for medical
        conditions that you have now or have had in the past, including any
        previously paid for by us.
      </p>
    </React.Fragment>
  ),
  ShopAroundContentForFourthRenewalFCA: (
    <React.Fragment>
      <p>
        Please check to make sure your cover is still appropriate for your
        needs.
      </p>
      <p>
        You have been with us for a number of years. You may be able to get the
        insurance cover you want at a better price if you shop around. We also
        have a range of other options which you may wish to consider.
      </p>
      <p>
        Not all insurance providers offer the same features and benefits and you
        may not be able to get the same cover with another insurer for medical
        conditions that you have now or have had in the past, including any
        previously paid for by us.
      </p>
    </React.Fragment>
  ),
  ShopAroundContentForPreFourthRenewalFCADiscount: (
    <React.Fragment>
      <p>
        As you either made a change to your cover or enjoyed a special offer
        this amount may be different to the amount shown on your documents last
        year.
      </p>
      <p>
        Please check to make sure your cover is still appropriate for your
        needs.
      </p>
      <p>
        Whilst we do have a range of options we can discuss with you, you may
        wish to compare the price and level of cover offered by other health
        providers Not all insurance providers offer the same features and
        benefits and you may not be able to get the same cover with another
        insurer for medical conditions that you have now or have had in the
        past, including any previously paid for by us.
      </p>
    </React.Fragment>
  ),
  ShopAroundContentForPreFourthRenewalFCA: (
    <React.Fragment>
      <p>
        Please check to make sure your cover is still appropriate for your
        needs.
      </p>
      <p>
        Whilst we do have a range of options we can discuss with you, you may
        wish to compare the price and level of cover offered by other health
        providers. Not all insurance providers offer the same features and
        benefits and you may not be able to get the same cover with another
        insurer for medical conditions that you have now or have had in the
        past, including any previously paid for by us.
      </p>
    </React.Fragment>
  ),
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help",
    HelpSet: [
      {
        Question: "How do I add other options to my cover?",
        Answer: {
          Any: (props, params) => (
            <p>
              To amend the options on your plan, we'll need to speak to you.
              Please call our team of Personal Advisers on{" "}
              <strong>{getPhone(props)}</strong>. Lines are open{" "}
              {getOpeningHours(props)}.
            </p>
          ),
          HOL: (props, params) => (
            <p>
              To amend the options on your policy, we'll need to speak to you.
              Please call our team of Personal Advisers on{" "}
              <strong>{getPhone(props)}</strong>. Lines are open{" "}
              {getOpeningHours(props)}.
            </p>
          )
        }
      },
      {
        Question: "How do I see who's covered?",
        Answer: {
          Any: (
            <React.Fragment>
              <p>
                If you're the lead member, you can view everyone who's covered
                under your plan on the Cover details page, under 'Other people
                on my plan'.
              </p>
              <p>
                For confidentiality, if you're a family member, you can only
                view the lead member's details.
              </p>
            </React.Fragment>
          ),
          HOL: (
            <React.Fragment>
              <p>
                If you're the policyholder, you can view everyone who's covered
                under your policy on the Cover details page, under 'Other people
                on my policy'.
              </p>
              <p>
                For confidentiality, if you're a family member, you can only
                view the policyholder's details.
              </p>
            </React.Fragment>
          )
        }
      },
      {
        Question: "How do I change my personal details?",
        Answer: (props, params) => (
          <React.Fragment>
            <p>
              You can change your contact details and preferences in your
              profile.
            </p>
            <p>
              If you want to contact us about changing your name or payment date
              / method, please call our team of Personal Advisers on{" "}
              <strong>{getPhone(props)}</strong>. Lines are open{" "}
              {getOpeningHours(props)}.
            </p>
          </React.Fragment>
        )
      }
    ]
  }
};
